import React from "react";

import './howItWork.css'

import icon01 from './Image/icon-01.png'
import icon02 from './Image/icon-02.png'
import icon03 from './Image/icon-03.png'

const HowItWorks = () => {
  return (
    <div className="">
    <button className="border-dark mt-2 rounded-lg p-2 w-100 bg-white text-dark h6"><strong><u>How it works</u></strong>
    <div className='grid-container'>
                <div className='grid-item'>
                <button className='rounded-lg border border-dark rounded bg-warning p-2 w-75 text-dark h6'>Step 1</button>
                  <button className="rounded-lg rounded mt-1 w-200 bg-light-gray">
                  <div className=''>
                  <img className="ml-1  w-50" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Carousel/1.png"></img>
                  </div>
                  <div className='text-dark mb-2'>
                    <span  style={{fontSize:17}}className='p-2'>Provide the information needed for your device we'll provide an instant offer.</span>
                  </div>
                  </button>
                </div>
                 
                <div className='grid-item'>
                <button className='rounded-lg rounded  p-2 w-75 mt-2  border border-dark text-dark h6'>Step 2</button>
                  <button className="rounded-lg rounded mt-1 w-200 bg-yellow">
                  <div className='bg-'>
                  <img className="ml-1 w-50 " style={{background:''}} src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Carousel/3.png"></img>
                  </div>
                  <div className='text-dark mb-2'>
                    <span style={{fontSize:17}} className='p-2'>We send you a prepaid shipping label. You send your device(s) to us free of cost.</span>
                  </div>
                  </button>
                </div>
                  
                <div className='grid-item'>
                <button className='rounded-lg rounded bg-warning p-2 w-75 mt-2  border border-dark text-dark h6'>Step 3</button>
                  <button className="rounded-lg rounded mt-1 w-200 bg-light-gray">
                  <div className=''>
                  <img className="ml-1 w-50" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Carousel/2.png"></img>
                  </div>
                  <div className='text-dark mb-2'>
                    <span style={{fontSize:17}} className='p-2'>You get paid with the payment method of your choice like Cash, PayPal, E-trasfer(Interac).</span>
                  </div>
                  </button>
                </div>

          </div>  
      </button> 
    
                
        </div>
   
  
  )
}

export default HowItWorks
